import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-addeditmarketprices',
    templateUrl: './addeditmarketprices.component.html',
    styleUrls: ['./addeditmarketprices.component.css']
})
export class AddEditMarketPrice implements OnInit{
    element: any = {};
    myForm: any = FormControl;
    isEditMode: boolean;
    constructor(
        public dialogRef: MatDialogRef<AddEditMarketPrice>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private notifSer: NotificationsService,
        public userService: UserService,
        public fb: FormBuilder,
    ) {
        this.element = data;
        this.isEditMode = !!data._id;
        this.myForm = this.fb.group({
            ExchangeName: ['', [Validators.required]],
            BaseCurrency: ['', [Validators.required]],
            QuoteCurrency: ['', [Validators.required]],
            MarketPrice: ['', [Validators.required]],
            Id: ['', [Validators.required]],
        });

    }
    ngOnInit() {
    }
    async saveMarketPrice() {
        this.userService.csrf().subscribe(data => {
            const { notif } = defaults
            this.element['_csrf'] = data['_csrf'];
            if (this.myForm.valid) {
                this.userService.addEditMarketPrice(this.element).subscribe(data => {
                    if (data.status) {
                        this.notifSer.success('Success', data.message, notif)
                        this.dialogRef.close({ success: true, data: data });

                    } else this.notifSer.error('Error', data.message, notif);
                }, err => this.notifSer.error('Error', err.error.message, notif))
            }
        })

    }

}


// WEBPACK FOOTER //
// ./src/app/marketprices/addeditmarketprices/addeditmarketprices.component.ts